import { render } from "./LearnReward.vue?vue&type=template&id=cd263998&scoped=true"
import script from "./LearnReward.vue?vue&type=script&lang=js"
export * from "./LearnReward.vue?vue&type=script&lang=js"

import "./LearnReward.vue?vue&type=style&index=0&id=cd263998&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd263998"]])

export default __exports__